// extracted by mini-css-extract-plugin
module.exports = {"naver":"DownloadNav_naver__fP2_Q"};